import { useLanguage } from '../contexts/LanguageContext';
import { getTranslation } from '../services/languageService';

/**
 * Custom hook for getting translations
 * @returns {Function} Translation function that takes key and optional params
 */
export const useTranslation = () => {
  const { currentLanguage } = useLanguage();
  
  /**
   * Get translation for a key in the current language
   * @param {string} key - Translation key (supports nested keys like 'navigation.home')
   * @param {Object} params - Parameters to replace in translation (e.g., { name: 'John' })
   * @returns {string} Translated text
   */
  const t = (key, params = {}) => {
    return getTranslation(key, currentLanguage, params);
  };
  
  return t;
};

export default useTranslation;
